<div class="modal-header">
    <h4 class="modal-title">{{ employee.firstName }} {{ employee.lastName }} - Training and Certifications</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-6 col-12">
                <h5>Trainings and Certifications</h5>
                <wj-flex-grid
                    id="gridTrain"
                    #gridTrain
                    appAutoSize
                    [padding]="150"
                    (initialized)="trainGrid.initialize(gridTrain)"
                    [itemsSource]="trainGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Train Code'" [binding]="'trainCode'" [width]="180"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Exp Date'" [binding]="'udExpDate'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Cert Period'" [binding]="' '" [width]="100"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
            <div class="col-sm-6 col-12">
                <h5>Skills</h5>
                <wj-flex-grid
                    id="gridCert"
                    #gridCert
                    appAutoSize
                    [padding]="150"
                    (initialized)="certGrid.initialize(gridCert)"
                    [itemsSource]="certGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [width]="180"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Code Description'" [binding]="'codeDescription'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Cert Date'" [binding]="'certDate'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Expire Date'" [binding]="'expireDate'" [width]="130"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>
    </div>
</form>
